export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('INDEX.form_label_bookContractNo') || '外运单号',
    field: 'bookContractNo',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_containerContractNo') || '外运子单号',
    field: 'containerContractNo',
    width: 130,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_poBookContractNo') || 'PO外运合同号',
    field: 'poBookContractNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_retailerPo') || '零售商PO',
    field: 'retailerPo',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_editContainerNo') || '编辑柜号',
    field: 'editContainerNo',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_containerNo') || '集装箱号',
    field: 'containerNo',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_sealNo') || '箱封号',
    field: 'sealNo',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.goods_label_identifyGoodsNo') || '产品识别编号',
    field: 'identifyGoodsNo',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.goods_label_orderGoodsName') || '产品名称',
    field: 'orderGoodsName',
    minWidth: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_goods_label_orderGoodsColor') || '产品颜色',
    field: 'orderGoodsColor',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_goods_label_goodsSpecDisplay') || '产品规格',
    field: 'goodsSpecDisplay',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.goods_label_isGroup') || '是否套装',
    field: 'isGroupName',
    width: 80,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_goodsQty') || '产品数量',
    field: 'goodsQty',
    isTotalColumn: true,
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_boxQty') || '箱数',
    field: 'containerBoxQty',
    isTotalColumn: true,
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.master_category_categoryName') || '分类名称',
    field: 'categoryName',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.shipment_customs_code_hscode') || '报关hscode',
    field: 'hscode',
    width: 130,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.shipment_customs_code_hscodeName') || '报关名称',
    field: 'hscodeName',
    width: 140,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l('INDEX.shipment_customs_code_hscodeNameEn') || '报关英文名称',
    field: 'hscodeNameEn',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_scm') || '执行工厂',
    field: 'scmName',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_settlementFactory') || '结算工厂',
    field: 'settlementFactoryName',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.shipment_table_subOldPriceAmount') || '工厂金额',
    field: 'subOldPriceAmount',
    isTotalColumn: true,
    width: 150,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue, row }) => {
      return cellValue
        ? [cellValue, row.currencyUnit].filter(Boolean).join(' ')
        : ''
    },
  },
  {
    title: that.$l('INDEX.shipment_table_priceFormula') || '工厂金额计算公式',
    field: 'priceFormula',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.shipment_table_subPriceAmount') || '计算工厂金额',
    field: 'subPriceAmount',
    isTotalColumn: true,
    width: 150,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue, row }) => {
      return cellValue
        ? [cellValue, row.currencyUnit].filter(Boolean).join(' ')
        : ''
    },
  },
  {
    title: that.$l('INDEX.table_subSalePriceAmount') || '客户金额',
    field: 'subSalePriceAmount',
    isTotalColumn: true,
    width: 150,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue, row }) => {
      return cellValue
        ? [cellValue, row.salesCurrencyUnit].filter(Boolean).join(' ')
        : ''
    },
  },
  {
    title:
      that.$l('INDEX.shipment_table_declarationFormula') || '报关金额计算公式',
    field: 'declarationFormula',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.shipment_table_formulaDeclarationAmount') || '公式计算报关金额',
    field: 'formulaDeclarationAmount',
    isTotalColumn: true,
    width: 150,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue, row }) => {
      return cellValue
        ? [cellValue, row.salesCurrencyUnit].filter(Boolean).join(' ')
        : ''
    },
  },
  {
    title: that.$l('INDEX.shipment_table_changeDeclarationAmount') || '报关调整金额',
    field: 'changeDeclarationAmount',
    isTotalColumn: true,
    width: 150,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue, row }) => {
      return [cellValue || '0', row.salesCurrencyUnit].filter(Boolean).join(' ')
    },
    editRender: {
      enabled: that.shipmentStatus === 'C',
      name: 'ElInputNumber',
      props: {
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        precision: 4,
        'controls-position': 'right',
        size: 'mini',
      },
      events: {
        blur({ row, column }) {
          if (that.$refs.vxegrid.isUpdateByRow(row, column.property)) {
            that.changeDeclarationAmount({
              shipmentPackingListCode: row.shipmentPackingListCode,
              changeDeclarationAmount: row[column.property],
            })
          }
        },
      },
    },
  },
  {
    title: that.$l('INDEX.shipment_table_subDeclarationAmount') || '报关金额',
    field: 'subDeclarationAmount',
    isTotalColumn: true,
    width: 150,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue, row }) => {
      return cellValue
        ? [cellValue, row.salesCurrencyUnit].filter(Boolean).join(' ')
        : ''
    },
  },
]
